<template>
  <!-- pretraga samo oglasa (naslov, kategorija, mesto); iznad naslova "Oglasi na pijaci" -->
  <SiteSearch placement="inline"
              scope="oglasi"
              placeholder="Pretraži oglase…"
              noun="oglasa"
              label="Pretraga oglasa: traži samo među oglasima, po nazivu, kategoriji i mestu. Za pretragu celog sajta koristite polje na vrhu stranice."
              results-route="oglasi-pretraga"
              results-path="/oglasi-pretraga" />
</template>

<script setup>
import SiteSearch from '~/components/search/SiteSearch.vue'
</script>
